<template>
  <v-app>
    <!-- <v-navigation-drawer v-model="drawer" app>
      
    </v-navigation-drawer> -->
    
    <h2 class="appName">Loggrapher</h2>
    

    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({    
  }),
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@200;400&display=swap');
#app { font-family: 'Inter', sans-serif;}
.appName {
  padding:16px;
  padding-bottom: 0;
}
</style>
